import withGeneralContexts from './withGeneralContexts';

export default withGeneralContexts;
